import Vue from 'vue';

import Categories from './Categories';
import Product from './Product';

Vue.component('brku-product-stock-categories', Categories);
Vue.component('brku-product-stock', Product);
